export enum HelpdeskTaskStatusEnum {
  NEW = 'NEW',
  IN_PROCESS = 'IN_PROCESS',
  COMPLETED = 'COMPLETED',
  DELAYED = 'DELAYED',
  WAITING_FOR_ANSWER = 'WAITING_FOR_ANSWER',
}
